







import Vue from "vue"
import { BannerListView } from "~/clApi/viewModel/ad"
import PMobileCarouselBanner from "~/components/custom/banner/PMobileCarouselBanner.vue"

interface DataType {
  bannerList: BannerListView | null
}

export default Vue.extend({
  components: {
    PMobileCarouselBanner,
  },
  data(): DataType {
    return {
      bannerList: null,
    }
  },
  beforeMount() {
    this.fetchBannerList()
  },
  methods: {
    async fetchBannerList() {
      this.bannerList = await this.$clApi.main.general.ad.read.getBannerList()
    },
  },
})
